export const authRu = {
  loginError: "Неверный логин или пароль",
  noAdminAccess: "Учётная запись не имеет доступа в админку",
};

export const authEn = {
  loginError: "Invalid login or password",
  noAdminAccess: "This account does not have admin access",
};

export const authAz = {
  loginError: "Yanlış login və ya şifrə",
  noAdminAccess: "Hesabın admin panelinə girişi yoxdur",
};
